// browser IE
export const isIE = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
};
// browser Safari
export const isSafari = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    return navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') === -1;
};
